import { render } from "./VeiculosRevisao.vue?vue&type=template&id=ce6311f6&scoped=true&ts=true"
import script from "./VeiculosRevisao.vue?vue&type=script&lang=ts"
export * from "./VeiculosRevisao.vue?vue&type=script&lang=ts"

import "./VeiculosRevisao.vue?vue&type=style&index=0&id=ce6311f6&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6311f6"]])

export default __exports__